export default "__VITE_ASSET__w9Ns_spd__"